import { openBlock as r, createElementBlock as t, createElementVNode as l } from "vue";
const e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function o(n, a) {
  return r(), t("svg", e, [...a[0] || (a[0] = [
    l("path", {
      fill: "currentColor",
      d: "M18 3a2 2 0 0 1 2 2v14a2 2 0 0 1-1.796 1.99L18 21H5l-.204-.01a2 2 0 0 1-1.785-1.786L3 19V5a2 2 0 0 1 2-2zM5 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      d: "M10 10a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2z"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      d: "M19 15v1h-7v-1zm1-1v-4a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1v1a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h7l.204.01A2 2 0 0 1 21 10v4l-.01.204a2 2 0 0 1-1.786 1.785L19 16v-1a1 1 0 0 0 1-1"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      d: "M15 12a1 1 0 1 0-1 1v1a2 2 0 1 1 0-4 2 2 0 0 1 0 4v-1a1 1 0 0 0 1-1"
    }, null, -1)
  ])]);
}
const c = { render: o };
export {
  c as default,
  o as render
};
